const PDP_BASE_TEMPLATES = ['SINGLE_UNIT_VR', 'CONVENTIONAL_LODGING'];
export const isBasePdpTemplate = (value: string) => PDP_BASE_TEMPLATES.includes(value);

export const isPdpTemplate = (value: string) =>
  PDP_BASE_TEMPLATES.some(baseTemplate => baseTemplate.concat('_LARGE') === value || baseTemplate.concat('_SMALL') === value);

const SRP_TEMPLATES = ['LIST_VIEW', 'SPLIT_VIEW', 'LIST_VIEW_PILLS_EXP'] as const;
type SrpTemplateTuple = typeof SRP_TEMPLATES;
export type SrpTemplate = SrpTemplateTuple[number];

export const isSrpTemplate = (value: string): value is SrpTemplate => SRP_TEMPLATES.includes(value as SrpTemplate);
